import React from "react";
import { Box } from "@mui/material";
import SelectField from "../SelectField";
import LabeledTextField from "../LabeledTextField";
import RKKQuartersTable from "./RKKQuartersTable";

const SPHERE_OPTIONS = ["торговля", "производство", "строительство", "сфера услуг", "проект"];
const OFFSHORE_OPTIONS = ["нет", "да"];
const BANK_LIMIT_OPTIONS = ["до 5%", "> 5%"];

const RKKRatingTab = ({ data, onUpdate }) => {
  const rating = data.rating || {};
  const allQuarters = rating.quarters || [];
  const startOffset = Math.max(0, allQuarters.length - 5);
  const displayQuarters = allQuarters.slice(startOffset);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "0px", paddingBottom: "16px" }}>
      <SelectField
        label="Сфера деятельности"
        value={rating.sphereOfActivity || ""}
        onChange={(v) => onUpdate("rating.sphereOfActivity", v)}
        options={SPHERE_OPTIONS}
      />
      <SelectField
        label="Резидент офшорной зоны"
        value={rating.isOffshoreResident || ""}
        onChange={(v) => onUpdate("rating.isOffshoreResident", v)}
        options={OFFSHORE_OPTIONS}
      />
      <SelectField
        label="Лимит / Капитал Банка"
        value={rating.bankLimitCapital || ""}
        onChange={(v) => onUpdate("rating.bankLimitCapital", v)}
        options={BANK_LIMIT_OPTIONS}
      />

      {displayQuarters.length > 0 ? (
        <RKKQuartersTable
          quarters={displayQuarters}
          startOffset={startOffset}
          ratingData={rating}
          onUpdate={onUpdate}
        />
      ) : (
        <Box sx={{ color: "#54606F", fontSize: "14px", padding: "12px 0" }}>
          Нет данных по кварталам
        </Box>
      )}

      <Box sx={{ display: "flex", flexDirection: "column", gap: "0px", marginTop: "16px" }}>
        <LabeledTextField
          label="ФИО подготовил:"
          value={rating.preparedBy || ""}
          onChange={(v) => onUpdate("rating.preparedBy", v)}
          labelWidth="200px"
        />
        <LabeledTextField
          label="ФИО проверил:"
          value={rating.checkedBy || ""}
          onChange={(v) => onUpdate("rating.checkedBy", v)}
          labelWidth="200px"
        />
        <LabeledTextField
          label="Дата:"
          value={rating.documentDate || ""}
          onChange={(v) => onUpdate("rating.documentDate", v)}
          labelWidth="200px"
        />
      </Box>
    </Box>
  );
};

export default RKKRatingTab;
